import { onIdTokenChanged, signInWithEmailAndPassword, signOut, type User } from 'firebase/auth'
import { auth } from '@/config/firebase'
import { isRole, type Role } from '@/types/user'

/** Sign in with email + password. Throws a FirebaseError on failure. */
export function login(email: string, password: string) {
  return signInWithEmailAndPassword(auth, email, password)
}

export function logout(): Promise<void> {
  return signOut(auth)
}

/**
 * Subscribe to auth state and ID-token (custom-claim) changes.
 * Returns an unsubscribe function.
 */
export function subscribe(callback: (user: User | null) => void) {
  return onIdTokenChanged(auth, callback)
}

/** Resolve the `role` custom claim from the user's ID token. */
export async function getRole(user: User): Promise<Role | null> {
  const { claims } = await user.getIdTokenResult()
  return isRole(claims.role) ? claims.role : null
}
